// extracted by extract-css-chunks-webpack-plugin
module.exports = {"loading":"icon-styles__loading___1mVKM","spin":"icon-styles__spin___LGQqu","tick":"icon-styles__tick___1i6nJ","tick-container":"icon-styles__tick-container___gfNoD","tickContainer":"icon-styles__tick-container___gfNoD","tickHorizontal":"icon-styles__tickHorizontal___3TqEu","tickVertical":"icon-styles__tickVertical___26NVA"};
    if(module.hot) {
      // 1749173858772
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  